import { WorkflowModals } from './constants';

type Props = {
  modalType: keyof typeof WorkflowModals;
};

export const WorkflowModal = ({ modalType, ...props }: Props) => {
  const ModalComponent = WorkflowModals[modalType];

  return <ModalComponent {...(props as any)} />; // We should make this a generic type, where the consumer passes in the prop types at the call site
};
